import type { WalletAddressFormSchema } from 'BreetComponents';
import {
	type IApiResponse,
	type IAuthSettings,
	type IDropDownItem,
	type ITabProps,
	type IUseFormData,
	type IUseFormStageNavigator,
	type IWalletAddress,
	type IWalletInfo,
	type IWalletInfoOptionProps,
	type NetworkType,
} from 'BreetHelpers';

export type WITHDRAWREQUESTUSDSTAGETYPE =
	| 'withdraw-funds'
	| 'add-wallet-address'
	| 'saved-wallet-address'
	| 'manage-wallet-address'
	| 'scan-wallet-address'
	| 'crypto-transaction-details';

export const requestPaymentUsdStageTitle: Record<WITHDRAWREQUESTUSDSTAGETYPE, string> = {
	'withdraw-funds': 'Withdraw Stablecoin',
	'saved-wallet-address': 'Saved Address',
	'add-wallet-address': 'Add Wallet Address',
	'manage-wallet-address': 'Manage Address',
	'scan-wallet-address': 'Scan Address',
	'crypto-transaction-details': 'Withdraw Stablecoin Details',
};

export const tabs = ['Send Crypto'] as const;

export type TABTYPE = (typeof tabs)[number];

export interface IWithdrawUsdRequestContext {
	formDataContextProps: IUseFormData<typeof WalletAddressFormSchema>;
	tokenOptions: IDropDownItem[];
	walletInfoOptions: IWalletInfoOptionProps[];
	walletInfoData?: IApiResponse<IWalletInfo>;
	tabProps: ITabProps<TABTYPE>;
	authSettings: IAuthSettings | undefined;
	resetWalletAddressProps: () => void;
	handleSelectAddress: (item: IWalletAddress) => Promise<never[] | undefined>;
}

export interface ISendCryptoAlternativeProps {
	isSavedWalletAddressesEmpty: boolean;
	navigator: IUseFormStageNavigator<WITHDRAWREQUESTUSDSTAGETYPE>;
	handleScanAddress: () => void;
}

export interface INetworkProps {
	network: NetworkType;
	avatar: string;
}
